// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"061298c7","672":"c7089c57","842":"638b52ab"}[chunkId] + ".chunk.js";
};